import { render } from "./CandleForm.vue?vue&type=template&id=01d2accc&scoped=true&lang=html"
import script from "./CandleForm.vue?vue&type=script&lang=js"
export * from "./CandleForm.vue?vue&type=script&lang=js"

import "./CandleForm.vue?vue&type=style&index=0&id=01d2accc&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d2accc"]])

export default __exports__